Vendd.Scripts.load(function () {

    var doSetBundleItems = function (control, parentId, skuId, quantity) {

        var state = Vendd.Product.Controller.getState();
        var bundleItems = state.bundleItems;

        for (var i = 0; i < bundleItems.length; i++) {
            if (bundleItems[i].parentProductId === parentId) {

                if (!!skuId) 
                    bundleItems[i].productId = skuId;

                quantity = quantity || 0;
                if (quantity >= 0)
                    bundleItems[i].quantity = quantity;
            }
        }

        Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.SetBundleItems(bundleItems));
    }

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-bundleitems', function (envelope) {

        var $context = envelope.message.data.context,
            $bundleItemList = $('.x-product-details-bundleitems .js-bundle-item-list', $context),
            $controls = $('.js-bundle-item', $bundleItemList);

        if ($controls.length < 1)
            return;

        $.each($controls, function (i, control) {
            var $control = $(control);
            var parentProductId = $control.data('parent-id');
            var productId = $control.data('selected-id');
            var quantity = 0;

            $control.on('change', '.js-quantity', function (e) {
                
                var $this = $(this);
                quantity = parseInt($this.val());

                doSetBundleItems(control, parentProductId, productId, quantity);
            });

            var $versionSelector = $('.x-product-details-version-selector', $control);

            if ($versionSelector.data('type') === 'list') {

                $versionSelector.on('click', '.js-bundle-item-version-selector', function (e) {

                    var $this = $(this);
                    if ($this.hasClass('selected'))
                        return;

                    productId = parseInt($this.data('value'));

                    doSetBundleItems(control, parentProductId, productId, null);
                });
            };

            if ($versionSelector.data('type') === 'dropdown') {

                $versionSelector.on('change', '.js-bundle-item-version-selector', function (e) {

                    var $this = $(this);

                    productId = parseInt($this.val());

                    doSetBundleItems(control, parentProductId, productId, null);
                });
            };



        });
    });
});
